// Parallax backgrounds of blocks (blocks/_frame.html.twig sets .jarallax). Jarallax is a chunk of its own, loaded only on
// pages with such a block.
export function initJarallax () {
    const elements = document.querySelectorAll('.jarallax');
    if (!elements.length) {
        return;
    }

    import(/* webpackChunkName: "jarallax" */ 'jarallax').then(({jarallax}) => {
        jarallax(elements, {
            //speed: 0.2,
            //type: 'scroll', //scroll, scale, opacity, scroll-opacity, scale-opacity
            /*disableParallax: function () {
                return /iPad|iPhone|iPod|Android/.test(navigator.userAgent);
            },*/
            disableVideo: function () {
                return /iPad|iPhone|iPod|Android/.test(navigator.userAgent);
            }
        });
    });
}
